import React from "react";
function PrivacyPolicyPage() {
  return (
    <main className="privacy-page">
      <section className="privacy-card">
        <h1>Privacy Policy</h1>
        <p><strong>Last updated:</strong> Sept 8, 2026</p>
        <p>
          This website provides aviation-related calculators and preflight
          planning tools for informational and educational purposes.
        </p>

        <h2 id="mobile-app">ToldCardApp Data Practices</h2>
        <p>
          The ToldCardApp mobile application stores the following data locally on
          your device only, using the device&apos;s local storage:
        </p>
        <ul>
          <li>Airplane profiles, tail numbers, and performance data you enter</li>
          <li>
            V-speeds, weight &amp; balance, navigation logs, weather briefings,
            and approach briefing data you enter
          </li>
          <li>
            Photos you choose to add to an airplane&apos;s profile, selected
            from your device&apos;s photo library
          </li>
        </ul>
        <p>
          This data is stored entirely on your device and is not transmitted to
          us, to any server, or to any third party. We do not have access to
          this data, and it is not used for any purpose other than displaying it
          back to you within the app.
        </p>
        <p>
          The app requests access to photos only when you choose
          to add a picture to an airplane profile. Photos you select are copied
          into the app&apos;s local storage; the app does not otherwise access,
          scan, or transmit your photo library.
        </p>
        <p>
          The app does not include advertising, analytics, or tracking software
          of any kind, and does not collect any information about your usage of
          the app.
        </p>
        <p>
          If you delete the app, locally stored app data may be deleted along
          with the app, subject to the backup and restore behavior of your
          device and operating system.
        </p>

        <h2>Information We Collect</h2>
        <p>
          This site may collect limited non-personal information such as browser
          type, device type, pages visited, and general usage data. This
          information may be used to improve site performance and usability.
        </p>
        <h2>Cookies and Advertising</h2>
        <p>
          This site may use cookies, web beacons, IP addresses, or similar
          technologies through third-party services such as Google AdSense or
          Google Analytics. Third-party vendors, including Google, may use
          cookies to serve ads based on a user&apos;s prior visits to this site
          or other websites.
        </p>
        <p>
          Users may opt out of personalized advertising by visiting Google Ads
          Settings. Users may also opt out of some third-party vendors&apos; use
          of cookies for personalized advertising by visiting applicable
          industry opt-out pages.
        </p>
        <h2>Third-Party Links</h2>
        <p>
          This site may contain links to external websites. No responsibility is
          assumed for the privacy practices, content, or accuracy of third-party
          websites.
        </p>
        <h2>Data Security</h2>
        <p>
          Reasonable efforts are made to protect this website, but no method of
          transmission or storage is completely secure.
        </p>
        <h2>Changes to This Policy</h2>
        <p>
          This Privacy Policy may be updated from time to time. Any updates will
          be posted on this page with a revised date.
        </p>
        <h2>Contact</h2>
        <p>
          For questions about this Privacy Policy, use the contact information
          provided on the Contact page.
        </p>
      </section>
    </main>
  );
}
export default PrivacyPolicyPage;